module.exports = __webpack_public_path__ + "assets/CircleTangentCLDetailed.348b5cefe3cf95295ccd4116ed5ed1f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/CircleTangentCLDetailed.png
// module id = 492
// module chunks = 0